import { ComponentProps, useEffect, useRef } from "react";

export const inputFocusStyles = [
    //
    "transition-shadow ease-out duration-300",
    // border
    "outline outline-transparent",
    "focus:outline-blue-500",
    // shadow
    "ring-8 ring-transparent",
    "focus:ring focus:ring-blue-200",
].join(" ");

export const inputBlockStyles = [
    "block text-13 w-full rounded-md bg-[var(--diagram-control-bg)]",
    "text-[var(--slate12)]",
    "border border-[var(--diagram-control-border)]",
].join(" ");

export const inputDisabledStyles = [
    //
    "disabled:text-[var(--slate10)]",
].join(" ");

interface Props extends ComponentProps<"input"> {
    onValueChange?: (value: string) => void;
    forceAutoFocus?: boolean;
    placeholder?: string;
    extraStyle?: string;
    paddingStyle?: string;
}

export type { Props as InputProps };

export const Input = (props: Props): JSX.Element => {
    const {
        onValueChange,
        forceAutoFocus,
        placeholder,
        extraStyle,
        paddingStyle,
        ...native
    } = props;

    const ref = useRef<HTMLInputElement>(null);

    useEffect(() => {
        if (!forceAutoFocus) return;
        window.setTimeout(() => {
            ref.current?.focus();
        }, 100);
    }, [forceAutoFocus]);

    return (
        <input
            className={[
                //
                inputFocusStyles,
                inputBlockStyles,
                paddingStyle ? paddingStyle : "py-1.5 px-2",
                inputDisabledStyles,
                extraStyle ? extraStyle : "",
            ].join(" ")}
            onChange={(event) => {
                onValueChange?.(event.currentTarget.value);
            }}
            onClick={(e) => {
                e.currentTarget.focus();
                e.stopPropagation();
            }}
            ref={ref}
            placeholder={placeholder}
            {...native}
        />
    );
};
